import { z } from "zod";

// t("PENDING")
// t("APPROVED")
// t("DECLINED")

export const estimateStatusEnum = z.enum(["PENDING", "APPROVED", "DECLINED"]);

export type EstimateStatus = z.infer<typeof estimateStatusEnum>;
